/**
 * Time + duration formatters. Kept dependency-free so mocks and the future
 * test suite (T22.1) stay trivial; date-fns adoption can wrap these later.
 */

export function formatDuration(ms, { short = false } = {}) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return short ? `${hours}h ${minutes}m` : `${hours}h ${minutes}m ${seconds}s`;
  }

  if (minutes > 0) {
    return short ? `${minutes}m` : `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
}

export function formatRelativeTime(timestamp, { now = Date.now() } = {}) {
  const delta = now - timestamp;

  if (delta < 45 * 1000) return 'just now';
  if (delta < 90 * 1000) return '1m ago';

  const minutes = Math.floor(delta / (60 * 1000));
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function formatClock(timestamp) {
  return new Date(timestamp).toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

/**
 * Compact "x ago" durations for connection surfaces (S5.3/S7) — seconds under
 * a minute, whole minutes beyond. Kept here (dependency-free) like the rest
 * of the module.
 */
export function formatDurationCompact(ms) {
  const seconds = Math.max(0, Math.floor(ms / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  return `${Math.floor(minutes / 60)}h`;
}
